import "@shoelace-style/shoelace/dist/components/card/card.js";

import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import { litIf } from "../LitUtils";

@customElement("ds-settings-card")
export class SettingsCard extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }

            sl-card {
                width: 100%;
            }

            sl-card [slot="header"] {
                display: flex;
                align-items: center;
                flex-direction: row;
                gap: 1em;
            }

            sl-card [slot="header"] sl-icon {
                font-size: 1.5em;
            }

            sl-card h3 {
                margin: 0;
            }

            sl-card sl-icon-button {
                font-size: var(--sl-font-size-medium);
            }

            sl-card::part(body) {
                margin-top: 0;
                padding-top: 0;
            }

            sl-card::part(base) {
                background-color: transparent;
            }
        `,
    ];
    @property({ type: String }) label = "";
    @property({ type: String }) iconName = "";
    @property({ type: Boolean }) onlyAuthenticated = false;

    override render() {
        return html`${litIf(
            !this.onlyAuthenticated || (this.onlyAuthenticated && !!this._kernel.user),
            () =>
                html`<sl-card class="ds-box-shadow">
                    <div slot="header">
                        <sl-icon name=${this.iconName}></sl-icon>
                        <h3>${this.label}</h3>
                    </div>
                    <slot></slot>
                </sl-card>`
        )}`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-settings-card": SettingsCard;
    }
}
